/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_project': {
    width: 22,
    height: 20,
    viewBox: '0 0 22 20',
    data: '<defs><path pid="0" d="M1 2h22v14H1V2zm3 3v8h16V5H4zM1 19h22v3H1v-3z" id="svgicon_icon_service_project_a"/></defs><g transform="translate(-1 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_project_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_project_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_project_a"/><g mask="url(#svgicon_icon_service_project_b)" _fill="#A156DD"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_project.js